import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import styles from "./TopHeader.module.css";

const PATH_TITLES = {
  "/dashboard": "Dashboard",
  "/properties": "Properties",
  "/amenities": "Amenities",
  "/services": "Services",
  "/parking-management": "Parking Management",
  "/guard/visitors": "Gate Terminal",
  "/admin/gate-entry-logs": "Gate Entry Logs",
  "/guard/expected-visitors": "Expected Visitors",
  "/users": "People Directory",
  "/users/import": "Import Users",
  "/society-chats": "Society Chats",
  "/send-notifications": "Notice Broadcasts",
  "/support": "Support Tickets",
  "/settings": "System Settings",
  "/system-logs": "System Logs",
  "/databaseviewer": "Database Explorer",
  "/resident/invites": "My Invites",
  "/resident/visitors": "My Visitors",
  "/resident/my-bookings": "My Bookings",
  "/resident/amenities": "Amenities",
  "/resident/support-tickets": "Support Tickets",
  "/profile": "User Profile",
};

const Breadcrumbs = ({ customTitle }) => {
  const location = useLocation();
  const pathname = location.pathname;

  const currentLabel =
    customTitle || PATH_TITLES[pathname] || pathname.split("/").filter(Boolean).pop() || "Overview";

  return (
    <nav className={styles.breadcrumbNav} aria-label="Breadcrumbs">
      <Link to="/dashboard" className={styles.crumbLink}>
        Home
      </Link>
      <ChevronRight size={13} className={styles.crumbSeparator} />
      <span className={styles.crumbActive}>{currentLabel}</span>
    </nav>
  );
};

export default Breadcrumbs;
